var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.01,
    height: 14.219,
    viewBox: "0 0 10.01 14.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_44",
    "data-name": "Union 44",
    d: "M1.394,13.217A2.783,2.783,0,0,1,0,10.934a2.806,2.806,0,0,1,1.4-2.3,7.058,7.058,0,0,1,7.216,0A2.8,2.8,0,0,1,10.01,10.92a2.806,2.806,0,0,1-1.393,2.3,6.572,6.572,0,0,1-3.612,1A6.57,6.57,0,0,1,1.394,13.217Zm3.718-6.47H5.076a.577.577,0,0,0-.156,0,3.359,3.359,0,1,1,.206,0Z",
    fill: "#0075e9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.615578985f60f15c9c32c168f7756091.svg";
export { ForwardRef as ReactComponent };